import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ComboboxItem } from '@node-space/ui-components'
import { WalletSortOptions } from 'pages/Wallets/types'

export const useWalletSortOptions = () => {
  const { t } = useTranslation()

  const balanceSortOrderOptions: ComboboxItem[] = useMemo(
    () => [
      {
        leftText: t('walletsPage.highestBalances'),
        value: WalletSortOptions.BalanceDesc,
      },
      {
        leftText: t('walletsPage.lowestBalances'),
        value: WalletSortOptions.BalanceAsc,
      },
    ],
    []
  )

  return balanceSortOrderOptions
}
